import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MEM_56 } from "@/lib/programData";

export default function MarrakechLoop56Page() {
  return <ProgramTemplate program={PROGRAM_MEM_56} variant="mem" showJourneyChronology />;
}
